"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCaret = exports.getCaret = exports.getSizeTextInput = exports.setMaxHeightSelectBox = void 0;

var setMaxHeightSelectBox = function setMaxHeightSelectBox(size) {
  switch (size) {
    case 'tiny':
      return ['128px', '128px', '96px'];

    case 'small':
      return ['128px', '128px', '128px'];

    case 'medium':
      return ['193px', '193px', '193px'];

    case 'large':
      return ['193px', '193px', '224px'];

    case 'huge':
      return ['224px', '224px', '288px'];

    default:
      return ['128px', '128px', '128px'];
  }
};

exports.setMaxHeightSelectBox = setMaxHeightSelectBox;

var getSizeTextInput = function getSizeTextInput(size) {
  switch (size) {
    case 'huge':
      return 'small';

    case 'large':
      return 'small';

    case 'medium':
      return 'small';

    case 'small':
      return 'tiny';

    case 'tiny':
      return 'micro';

    default:
      return 'small';
  }
};

exports.getSizeTextInput = getSizeTextInput;

var getCaret = function getCaret(element) {
  var position = 0;

  if (document.selection) {
    element.focus();
    var selection = document.selection.createRange();
    selection.moveStart('character', -element.value.length);
    position = selection.text.length;
  } else if (element.selectionStart || element.selectionStart === '0') {
    position = element.selectionStart;
  }

  return position;
};

exports.getCaret = getCaret;

var setCaret = function setCaret(element, position) {
  if (!element.createTextRange) return;
  var range = element.createTextRange();
  range.collapse(true);
  range.moveEnd('character', position);
  range.moveStart('character', position);
  range.select();
};

exports.setCaret = setCaret;